// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"YoutubeEmbed_wrapper__0xgfo","iframe":"YoutubeEmbed_iframe__JIWLc"};